module.exports = __webpack_public_path__ + "img/DY.e1449ce8.png";